<script>
	import { createEventDispatcher, getContext } from 'svelte'
	import { slide } from 'svelte/transition'
	import { styles } from '../library/scripts/styles'
	import Slider from '../library/LayoutStuff/Slider.svelte'
	import { storeUsedColors } from '../library/scripts/Store.svelte'

	export let selectedColor = '#FFFFFF'
	export let initialValue = '100.00'
	export let transparent = '0'
	export let showTransparency = true
	export let ID = 0
	ID = parseInt(ID)

	const globals = getContext('globals')
	const fsXS = globals.fsXS

	let colorArray = [
		'#F0F8FF',
		'#FAEBD7',
		'#00FFFF',
		'#7FFFD4',
		'#F0FFFF',
		'#F5F5DC',
		'#FFE4C4',
		'#000000',
		'#FFEBCD',
		'#0000FF',
		'#8A2BE2',
		'#A52A2A',
		'#DEB887',
		'#5F9EA0',
		'#7FFF00',
		'#D2691E',
		'#FF7F50',
		'#6495ED',
		'#FFF8DC',
		'#DC143C',
		'#00FFFF',
		'#00008B',
		'#008B8B',
		'#B8860B',
		'#A9A9A9',
		'#006400',
		'#BDB76B',
		'#8B008B',
		'#556B2F',
		'#FF8C00',
		'#9932CC',
		'#8B0000',
		'#E9967A',
		'#8FBC8F',
		'#483D8B',
		'#2F4F4F',
		'#00CED1',
		'#9400D3',
		'#FF1493',
		'#00BFFF',
		'#696969',
		'#1E90FF',
		'#B22222',
		'#FFFAF0',
		'#228B22',
		'#FF00FF',
		'#DCDCDC',
		'#F8F8FF',
		'#FFD700',
		'#DAA520',
		'#808080',
		'#008000',
		'#ADFF2F',
		'#F0FFF0',
		'#FF69B4',
		'#CD5C5C',
		'#4B0082',
		'#FFFFF0',
		'#F0E68C',
		'#E6E6FA',
		'#FFF0F5',
		'#7CFC00',
		'#FFFACD',
		'#ADD8E6',
		'#F08080',
		'#E0FFFF',
		'#FAFAD2',
		'#D3D3D3',
		'#90EE90',
		'#FFB6C1',
		'#FFA07A',
		'#20B2AA',
		'#87CEFA',
		'#778899',
		'#B0C4DE',
		'#FFFFE0',
		'#00FF00',
		'#32CD32',
		'#FAF0E6',
		'#FF00FF',
		'#800000',
		'#66CDAA',
		'#0000CD',
		'#BA55D3',
		'#9370DB',
		'#3CB371',
		'#7B68EE',
		'#00FA9A',
		'#48D1CC',
		'#C71585',
		'#191970',
		'#F5FFFA',
		'#FFE4E1',
		'#FFE4B5',
		'#FFDEAD',
		'#000080',
		'#FDF5E6',
		'#808000',
		'#6B8E23',
		'#FFA500',
		'#FF4500',
		'#DA70D6',
		'#EEE8AA',
		'#98FB98',
		'#AFEEEE',
		'#DB7093',
		'#FFEFD5',
		'#FFDAB9',
		'#CD853F',
		'#FFC0CB',
		'#DDA0DD',
		'#B0E0E6',
		'#800080',
		'#663399',
		'#FF0000',
		'#BC8F8F',
		'#4169E1',
		'#8B4513',
		'#FA8072',
		'#F4A460',
		'#2E8B57',
		'#FFF5EE',
		'#A0522D',
		'#C0C0C0',
		'#87CEEB',
		'#6A5ACD',
		'#708090',
		'#FFFAFA',
		'#00FF7F',
		'#4682B4',
		'#D2B48C',
		'#008080',
		'#D8BFD8',
		'#FF6347',
		'#40E0D0',
		'#EE82EE',
		'#F5DEB3',
		'#FFFFFF',
		'#F5F5F5',
		'#FFFF00',
		'#9ACD32',
	]

	let showColors = false
	let opacity = 1
	let invertColor = 'hsla(0,0%,0%,1)'

	// for the used colors
	let usedColors = $storeUsedColors

	//if the initial vlaue is undefined (eg. is coming image tool)
	$: if (!initialValue) initialValue = '0.000111111'
	$: sliderValue = initialValue.toString().slice(0, 4)

	let dispatch = createEventDispatcher()

	//hex to hsl
	const hexToHsl = (hex) => {
		let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex)
		let r = parseInt(result[1], 16)
		let g = parseInt(result[2], 16)
		let b = parseInt(result[3], 16)
		let a = opacity

		;(r /= 255), (g /= 255), (b /= 255)
		let max = Math.max(r, g, b),
			min = Math.min(r, g, b)
		let h,
			s,
			l = (max + min) / 2

		if (max == min) {
			h = s = 0 // achromatic
		} else {
			let d = max - min
			s = l > 0.5 ? d / (2 - max - min) : d / (max + min)
			switch (max) {
				case r:
					h = (g - b) / d + (g < b ? 6 : 0)
					break
				case g:
					h = (b - r) / d + 2
					break
				case b:
					h = (r - g) / d + 4
					break
			}
			h /= 6
		}

		s = s * 100
		s = Math.round(s)
		l = l * 100
		l = Math.round(l)
		h = Math.round(360 * h)

		return 'hsla(' + h + ', ' + s + '%, ' + l + '%,' + a + ')'
	}

	function padZero(str, len) {
		len = len || 2
		const zeros = new Array(len).join('0')
		return (zeros + str).slice(-len)
	}

	//invert color
	const invert_color = (hex) => {
		hex = hex.slice(1)
		let r = parseInt(hex.slice(0, 2), 16)
		let g = parseInt(hex.slice(2, 4), 16)
		let b = parseInt(hex.slice(4, 6), 16)

		r = (255 - r).toString(16)
		g = (255 - g).toString(16)
		b = (255 - b).toString(16)

		const invHex = '#' + padZero(r) + padZero(g) + padZero(b)
		const invHsl = hexToHsl(invHex)
		return invHsl
	}

	const set_color = (c) => {
		if (c.indexOf('#') > -1) {
			selectedColor = hexToHsl(c)
			invertColor = invert_color(c)
		} else {
			selectedColor = c
			invertColor = c
		}

		showColors = false
		dispatch('setcolor', { color: selectedColor, hex: c })
	}

	const show_slider_value = (e) => {
		set_opacity(e.detail.value)
		sliderValue = e.detail.value.toFixed(2)
	}

	const set_transparent = () => {
		dispatch('settransparent', { color: 'hsla(0,0%,100%,0)' })
	}

	const set_opacity = (opacity) => {
		let selSplit
		document.getElementById('selectedColor' + ID).style.opacity = opacity
		//create the new hsla color
		let newHsla
		if (selectedColor && selectedColor !== 'transparent' && selectedColor.indexOf('#') < 0) {
			selSplit = selectedColor.split('(')

			let movLast = selSplit[1].slice(0, selSplit[1].length - 1)
			let s = movLast.split(',')
			newHsla = 'hsla(' + s[0] + ', ' + s[1] + ',' + s[2] + ',' + opacity + ')'

			dispatch('setopacity', { color: newHsla })
		}
	}
</script>

<main>
	{#if usedColors.length > 0}
		<div class="selected_title" use:styles={{ fsXS }}>used colors</div>
		<div class="colorContainer marginBottom">
			{#each usedColors as color}
				<div
					on:click={() => set_color(color)}
					on:keydown={() => set_color(color)}
					style="
					display: block;
					width: clamp(10px, 1.6vw, 25px);
					height: clamp(10px, 1.6vw, 25px);
					background-color: {color};
					margin-right: 5px;
					cursor: pointer;
					border:1px solid black;
					"
				/>
			{/each}
		</div>
	{/if}
	<div class="selectionContainer">
		<div class="selectedColor" id="selectedColor{ID}" use:styles={{ selectedColor, fsXS, invertColor }}>
			{sliderValue} %
		</div>
		<div
			class="caretContainer"
			on:click={() => (showColors = showColors === true ? false : true)}
			on:keydown={() => (showColors = showColors === true ? false : true)}
		>
			<div class="caret" />
		</div>
	</div>
	{#if showColors}
		<div class="colorContainer" transition:slide={{ duration: 1000 }}>
			{#each colorArray as color}
				<div
					class="colorSquare"
					style="background-color: {color}"
					on:click={() => set_color(color)}
					on:keydown={() => set_color(color)}
				/>
			{/each}
		</div>
	{/if}
	{#if showTransparency}
		<div class="sliderContainer">
			<Slider width="100" height="20" sizeUnit="px" {ID} range="1" {initialValue} on:sliderMove={show_slider_value} />
		</div>
		{#if transparent === '1'}
			<div class="transparent" on:click={set_transparent} on:keydown={set_transparent} use:styles={{ fsXS }}>
				set transparent
			</div>
		{/if}
	{/if}
</main>

<style>
	main {
		display: flex;
		flex-direction: column;
		align-items: center;
		padding: 10px;
		width: clamp(100px, 17vw, 250px);
	}

	.selected_title {
		display: flex;
		width: 100%;
		justify-content: flex-start;
		margin-bottom: 15px;
		font-size: var(--fsXS);
	}

	.transparent {
		display: flex;
		width: 100%;
		justify-content: center;
		font-size: var(--fsXS);
		cursor: pointer;
	}

	.transparent:hover {
		color: hsla(0, 0%, 100%, 1);
	}

	.selectionContainer {
		display: flex;
		justify-content: space-between;
		align-items: center;
		width: 100%;
		height: 30px;
		margin-bottom: 5px;
		border: 1px solid black;
	}
	.selectedColor {
		display: flex;
		justify-content: flex-end;
		align-items: center;
		padding-right: 20px;
		width: 80%;
		height: 100%;
		background-color: var(--selectedColor);
		font-size: var(--fsXS);
		color: var(--invertColor);
	}

	.marginBottom {
		margin-bottom: 15px;
	}

	.caretContainer {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 20%;
		height: 100%;
		background: transparent;
		border-left: 1px solid black;
		cursor: pointer;
	}

	.caretContainer:hover {
		background-color: red;
	}

	.caret {
		width: 0;
		height: 0;
		border-left: clamp(1px, 1vw, 10px) solid transparent;
		border-right: clamp(1px, 1vw, 10px) solid transparent;
		border-top: clamp(1px, 1vw, 10px) solid #555;
	}

	.colorContainer {
		display: grid;
		grid-template-columns: 0.2fr 0.2fr 0.2fr 0.2fr 0.2fr;
		justify-items: center;
		padding: 10px;
		width: 100%;
		height: clamp(100px, 13vw, 200px);
		border: 1px solid black;
		overflow-y: scroll;
	}

	.colorSquare {
		width: clamp(10px, 1.6vw, 25px);
		height: clamp(10px, 1.6vw, 25px);
		margin-bottom: 10px;
		cursor: pointer;
	}

	.sliderContainer {
		display: flex;
		justify-content: center;
		width: 100%;
	}
</style>
